import { render, staticRenderFns } from "./ListPersons.vue?vue&type=template&id=5a863a08&"
import script from "./ListPersons.vue?vue&type=script&lang=js&"
export * from "./ListPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports